import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function MessageBox({ message }) {
	return message ? (
		<Box>
			<Typography
				sx={{
					padding: { xs: '15px', sm: '25px' },
					backgroundColor: '#f3f2f2',
                    borderRadius: '15px',
					fontSize: { xs: '13px', sm: '14px' },
					lineHeight: '1.7',
				}}
			>
				{message}
			</Typography>
		</Box>
	) : null;
}
